import React, { useState } from 'react';
import {
  Container, Row, Col, Button, Form
} from 'react-bootstrap';
import Header from '../Header';
import Footer from '../Footer';
import { Link, useParams } from 'react-router-dom';
import ActionButton from '../ActionButton';
import { staticData } from '../../helpers/data';
import { getResourceUrl } from '../../Services/CommanFunctions';
import { sanitize, validateFormFields } from '../../utils/validationUtils';

function FacilitatorSignupStepThree({ nextStep, prevStep, handleFormData, handleSchool, values }) {
  const [error2, setError2] = useState({});
  let { id } = useParams();
  const student = JSON.parse(localStorage.getItem('student'));

  const validateForm = () => {
    console.log('values', values);

    const sanitizedData = {
      ...Object.keys(values).reduce((acc, key) => {
        acc[key] = sanitize(values[key]);
        return acc;
      }, {})
    };

    const errors = validateFormFields(sanitizedData, 'facilitator');
    setError2(errors);

    console.log('validation-errors', errors);

    // if (Object.keys(errors).length > 0) {
    //   return false;
    // }
    // return true;

    return Object.keys(errors).length === 0;
  };

  const submitFormData = (e) => {
    e.preventDefault();

    console.log('called submit!');

    if (validateForm()) {
      nextStep();
    }
  };

  const handleOnChange = (e) => {
    const { name, checked } = e.target;
    handleSchool(name, checked);
  };

  return (
    <>
      <Header />
      <section className="login-body" style={{ backgroundImage: 'url(\"images/signup-bg.jpg\")' }}>
        <Container>
          <Row>
            <Col md={12}>
              <div className="step-progress">
                <div className="step-progress-bar">
                  <div className="step-progress-percent" style={{ width: '75%' }}></div>
                </div>
                <div className="step-progress-text">
                  <h6>Accept Request</h6>
                  <h6>75% Completed</h6>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={9}>
              <div className="signup-box">
                <div className="signup-left">
                  <h4>{staticData?.verbiage?.facilitator[3]?.heading}</h4>
                  <p>{staticData?.verbiage?.facilitator[3]?.text}</p>
                  <div className="signup-step">
                    <ul><li></li><li></li><li className="active"></li><li></li></ul>
                  </div>
                </div>
                <div className="signup-right">
                  <Form onSubmit={submitFormData}>
                    <Row>
                      <Col md={12}>
                        <div className="faci-profile">
                          <div className="faci-profile-img">
                            <img src={student?.gender[0]?.icon_image ? getResourceUrl(student?.gender[0]?.icon_image) : 'images/avatar3.png'} alt="avatar" />
                          </div>
                          <h6>{student?.first_name + ' ' + student?.last_name}. | Student ID: {student?.student_code}</h6>
                          <p>Academic Year {staticData?.years?.getYearByValue(student.academic_year).label}</p>
                        </div>
                      </Col>
                      {/* <Col md={12}>
                        <Form.Group className="form-group mb-3">
                          <Form.Control type="text" name="facilitator_name" onChange={handleFormData("facilitator_name")} defaultValue={values.name} placeholder="Facilitator Name*" />
                          <span className="err">{error2?.facilitator_name}</span>
                        </Form.Group>
                      </Col> */}
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Control type="text" name="first_name" onChange={handleFormData("first_name")} defaultValue={values.first_name} placeholder="First Name*" />
                          <span className="err">{error2?.first_name}</span>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Control type="text" name="last_name" onChange={handleFormData("last_name")} defaultValue={values.last_name} placeholder="Last Name*" />
                          <span className="err">{error2?.last_name}</span>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Control type="tel" onChange={handleFormData("phone")} defaultValue={values.phone} placeholder="School/ Company Main Phone Number" />
                          <span className="err">{error2?.phone}</span>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Control type="password" name="password" onChange={handleFormData("password")} placeholder="Enter your new password*" />
                          <span className="err">{error2?.password}</span>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="form-group mb-3">
                          <Form.Control type="password" name="confirmpassword" onChange={handleFormData("confirmpassword")} placeholder="Confirm your password*" />
                          <span className="err">{error2?.confirmpassword}</span>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Select name="timezone" onChange={handleFormData("timezone")} defaultValue={values.timezone}>
                            <option disabled value=''>Select Time Zone*</option>
                            <option value="EST">EST</option>
                            <option value="CST">CST</option>
                            <option value="PST">PST</option>
                          </Form.Select>
                          <span className="err">{error2?.timezone}</span>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="signup-back-btn">
                      <Link onClick={prevStep} to="#" className="btn btn-link">Back</Link>
                      <ActionButton
                        type='submit'
                        title='Continue'
                        className='btn btn-primary btn-pill px-4'
                        requiredFields={[
                          // values?.facilitator_name,
                          values?.first_name,
                          values?.last_name,
                          values?.phone,
                          values?.password,
                          values?.confirmpassword,
                          values?.timezone
                        ]}
                      />
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
}

export default FacilitatorSignupStepThree;